(() => {
	angular
		.module('main')
		.directive('subscriptionInfoModal', subscriptionInfoModal);

	subscriptionInfoModal.$inject = [
		'$rootScope',
		'$http',
		'ambassadorsDataService',
		'timeService',
		'messageService',
		'utilsService'
	];

	function subscriptionInfoModal(
		$rootScope,
		$http,
		ambassadorsDataService,
		timeService,
		messageService,
		utilsService
	) {
		return {
			restrict: 'E',
			scope: {
				user: '=',
				userLocal: '<'
			},
			template: `<div id="subscriptionModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <btn-close></btn-close>
                                        <h3 class="modal-title">Membership</h3>
                                    </div>
                                    <div class="modal-body clearfix">
                                        <div class="text-nowrap">
                                            <h4>User: {{user.firstName}} {{user.lastName}}</h4>
                                        </div>
                                        <div class="text-nowrap">
                                            <h4>Email: {{user.email}}</h4>
                                        </div>
                                        <div class="text-nowrap" ng-show="!user.championForever">
                                            <h4>Subscription type: {{userLocal.subscriptionPlan !== null ? userLocal.subscriptionPlan
                                                : 'TRIAL'}}</h4>
                                        </div>
                                        <span ng-show="userLocal.subscriptionPlan != null">
                                            <div class="text-nowrap" ng-show="user.expirationDate">
                                                 <h4>Expiration date: {{user.expirationDate | date: dateLongPattern}}</h4>
                                            </div>
                                            <div class="text-nowrap" ng-show="!user.expirationDate">
                                                <h4>Subscribed</h4>
                                            </div>
                                        </span>
                                        <div ng-show="!user.championForever">
                                            <div class="text-nowrap">
                                                <h4>Free membership till {{user.companyActivatedAt | date: dateLongPattern}}</h4>
                                            </div>
                                            <div>
                                                <input placeholder="Put months of membership" class="form-control" type="number"
                                                       ng-model="monthsOfChampion">
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="modal-footer modal-foot">
                                            <button ng-hide="user.championForever" class="btn btn-accept btn-lg" 
                                                    ng-disabled="btn_disable" ng-click="giveFreeMonths()"
                                                    spinning-wheel is-spinning-wheel-active="isGiveSpinningWheelActive">
                                                Give
                                            </button>
                                            <button class="btn btn-default btn-lg" ng-disabled="btn_disable" data-dismiss="modal">Cancel</button>
                                            <button class="btn btn-accept btn-lg pull-right" ng-click="showMakeAmbassadorModal($event)"
                                                    ng-disabled="btn_disable" spinning-wheel 
                                                    is-spinning-wheel-active="isAmbassadorSpinningWheelActive">
                                                {{user.ambassador ? 'View Ambassador' : 'Make Ambassador'}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `,
			replace: true,
			transclude: true,
			link(scope) {
				scope.giveFreeMonths = function() {
					if (!scope.monthsOfChampion) {
						toastr.error('Fill count of months!');
						return;
					}

					scope.btn_disable = true;
					scope.isGiveSpinningWheelActive = true;
					const formData = new FormData();
					formData.append('email', scope.user.email);
					formData.append('countOfMonths', scope.monthsOfChampion);
					$http({
						method: 'POST',
						url: '/admin/rest/user/give',
						data: formData,
						transformRequest: angular.identity,
						headers: {
							'Content-Type': undefined
						}
					})
						.then(result => successGiveFreeMonths(result.data))
						.catch(messageService.showDefaultErrorMessage)
						.finally(() => {
							scope.btn_disable = false;
							scope.monthsOfChampion = null;
							scope.isGiveSpinningWheelActive = false;
						});
				};

				function successGiveFreeMonths(data) {
					if (data.message) {
						$('#subscriptionModal').modal('hide');
						toastr.success(data.message);
					} else {
						toastr.error(data.errorMessage);
					}
				}

				scope.showMakeAmbassadorModal = event => {
					if (scope.user.ambassador) {
						getAmbassadorInfo();
					}
					prepareUser();
					scope.isAmbassadorSpinningWheelActive = true;
					scope.btn_disable = true;
					utilsService.showNextModal(
						'#subscriptionModal',
						'#addAmbassadorCodeModal',
						event
					);
					scope.btn_disable = false;
					scope.isAmbassadorSpinningWheelActive = false;
				};

				function prepareUser() {
					if (!scope.user.startDate) {
						scope.user.startDate = new Date();
						scope.user.startDate.setHours(0, 0, 0, 0);
					}
				}

				function getAmbassadorInfo() {
					ambassadorsDataService
						.getAmbassadorInfo(scope.userLocal.id)
						.then(successGetAmbassadorInfo)
						.catch(messageService.showDefaultErrorMessage);
				}

				function successGetAmbassadorInfo(ambassador) {
					ambassador.isAmbassador = true;
					ambassador.startDate = timeService.createDateAsUTC(
						ambassador.startDate
					);
					ambassador.endDate = timeService.createDateAsUTC(ambassador.endDate);
					scope.user = angular.copy(ambassador);
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/admin/adminSubscriptionModal.js